module.exports = __webpack_public_path__ + "img/guide03.7ec929e0.png";